import SearchBar from 'components/SearchBar/SearchBar';
import ConfirmModal from 'components/UI/ConfirmPopup';
import ConnectedDeviceGroupsFeature from 'features/integrations/features/ConnectedDeviceGroups/index.web.jsx';
import { USGS_PROVISIONAL_STATEMENT } from 'features/integrations/features/ConnectedDevices/assets/USGSProvisionalStatment';
import { useState } from 'react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import 'styles/global.css';
import {
  selectUsgsProvisonalAccepted,
  setUsgsProvisonalAccepted,
} from '../../../../store/slices/Widget/widgetSlice';

export default function ConnectedDeviceGroups(props) {
  const dispatch = useDispatch();
  const provisionalAccepted = useSelector(selectUsgsProvisonalAccepted);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  return (
    <div className="d-flex flex-column gap-3 pt-3 h-100">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between flex-shrink-0">
        <div className="fs-4 fw-bold">Connected Device Groups</div>
        <div className="d-flex align-items-center gap-2">
          <span className="text-white-50 small">
            USGS data may be{' '}
            <span
              className="text-decoration-underline cursor-pointer text-white"
              onClick={() => setShowDisclaimerModal(true)}
            >
              provisional
            </span>
            .
          </span>
          <IoMdInformationCircleOutline
            className="rounded-circle bg-primary p-1 cursor-pointer flex-shrink-0"
            style={{ height: 26, width: 26 }}
            onClick={() => setShowDisclaimerModal(true)}
          />
          <SearchBar className="w-auto" />
        </div>
      </div>
      <ConfirmModal
        open={!provisionalAccepted || showDisclaimerModal}
        setOpen={setShowDisclaimerModal}
        options={['Continue']}
        callbacks={[
          () => {
            dispatch(setUsgsProvisonalAccepted(true));
            setShowDisclaimerModal(false);
          },
        ]}
        message={USGS_PROVISIONAL_STATEMENT}
        closeAction={() => {}}
        size="lg"
      />
      {/* Content */}
      <div className="flex-grow-1 overflow-auto min-h-0">
        <ConnectedDeviceGroupsFeature {...props} />
      </div>
    </div>
  );
}
